'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Switch = _interopDefault(require('@material-ui/core/Switch'));

var SwitchField = function (_a) {
    var checked = _a.checked, disabled = _a.disabled, onChange = _a.onChange, _b = _a.color, color = _b === void 0 ? 'primary' : _b;
    return (React__default.createElement(Switch, { checked: checked, onChange: onChange, disabled: disabled, color: color }));
};

exports.SwitchField = SwitchField;
